import { WaveBlockKind, WaveStatus } from "./types.js";
export function templateBlockId(templateId, index) {
    return `tpl-${templateId}-${index}`;
}
function block(templateId, index, kind, payload) {
    return { id: templateBlockId(templateId, index), kind, payload, sortIndex: index };
}
export const WaveTemplateCatalog = {
    blank: {
        templateId: "blank",
        title: "Nuova wave",
        subtitle: "Documento vuoto",
        initialStatus: WaveStatus.Draft,
        blocks: [block("blank", 0, WaveBlockKind.Text, { text: "" })],
    },
    briefCreative: {
        templateId: "brief.creative",
        title: "Brief creativo",
        subtitle: "Obiettivo, audience, deliverable",
        initialStatus: WaveStatus.Draft,
        blocks: [
            block("brief.creative", 0, WaveBlockKind.Heading, { text: "Brief creativo", level: 1 }),
            block("brief.creative", 1, WaveBlockKind.Text, {
                text: "Obiettivo:\n\nAudience:\n\nDeliverable:",
            }),
            block("brief.creative", 2, WaveBlockKind.Task, { title: "Raccogliere asset", taskDone: false }),
        ],
    },
    decisionProduct: {
        templateId: "decision.product",
        title: "Decisione prodotto",
        subtitle: "Opzioni, pro/contro, sign-off",
        initialStatus: WaveStatus.Review,
        blocks: [
            block("decision.product", 0, WaveBlockKind.Heading, { text: "Decisione", level: 1 }),
            block("decision.product", 1, WaveBlockKind.Decision, {
                title: "Quale opzione adottiamo?",
                choices: ["A", "B", "Rimandare"],
            }),
            block("decision.product", 2, WaveBlockKind.Signoff, {
                title: "Approvazione",
                requiredSubs: [],
                approvals: {},
            }),
        ],
    },
    retroTeam: {
        templateId: "retro.team",
        title: "Retro team",
        subtitle: "Cosa ha funzionato / da migliorare",
        initialStatus: WaveStatus.Draft,
        blocks: [
            block("retro.team", 0, WaveBlockKind.Heading, { text: "Retro", level: 1 }),
            block("retro.team", 1, WaveBlockKind.Text, {
                text: "✅ Funzionato:\n\n⚠️ Da migliorare:\n\n➡️ Action item:",
            }),
            block("retro.team", 2, WaveBlockKind.Poll, {
                title: "Energia del team",
                choices: ["🔥", "🙂", "😐", "😴"],
            }),
        ],
    },
    triageBug: {
        templateId: "triage.bug",
        title: "Triage bug",
        subtitle: "Severità, owner, next step",
        initialStatus: WaveStatus.Draft,
        blocks: [
            block("triage.bug", 0, WaveBlockKind.Heading, { text: "Bug", level: 1 }),
            block("triage.bug", 1, WaveBlockKind.Text, {
                text: "Descrizione:\n\nPassi per riprodurre:",
            }),
            block("triage.bug", 2, WaveBlockKind.Task, { title: "Assegnare owner", taskDone: false }),
        ],
    },
    onboardingClient: {
        templateId: "onboarding.client",
        title: "Onboarding cliente",
        subtitle: "Checklist kickoff",
        initialStatus: WaveStatus.Draft,
        blocks: [
            block("onboarding.client", 0, WaveBlockKind.Heading, { text: "Onboarding", level: 1 }),
            block("onboarding.client", 1, WaveBlockKind.Task, { title: "Accessi e inviti", taskDone: false }),
            block("onboarding.client", 2, WaveBlockKind.Task, {
                title: "Prima wave di lavoro",
                taskDone: false,
            }),
            block("onboarding.client", 3, WaveBlockKind.Signoff, {
                title: "Kickoff completato",
                requiredSubs: [],
                approvals: {},
            }),
        ],
    },
    all: [],
    find(templateId) {
        if (!templateId)
            return null;
        if (templateId === WaveTemplateCatalog.blank.templateId) {
            return WaveTemplateCatalog.blank;
        }
        return WaveTemplateCatalog.all.find((t) => t.templateId === templateId) ?? null;
    },
};
WaveTemplateCatalog.all = [
    WaveTemplateCatalog.briefCreative,
    WaveTemplateCatalog.decisionProduct,
    WaveTemplateCatalog.retroTeam,
    WaveTemplateCatalog.triageBug,
    WaveTemplateCatalog.onboardingClient,
];
